import { useEffect, useState } from "react";
import { Switch } from "@/components/ui/switch";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const ConfirmRemoveDialog = ({ open, title, description, onCancel, onConfirm, testId }) => {
  const [fromTemplate, setFromTemplate] = useState(false);
  useEffect(() => { if (open) setFromTemplate(false); }, [open]);
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="bg-[#15181E] border-[#2A2E39] text-white">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-400">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <label className="flex items-center justify-between gap-3 rounded-md border border-[#2A2E39] p-3">
          <span className="text-sm text-slate-300">Remover também dos próximos shows</span>
          <Switch checked={fromTemplate} onCheckedChange={setFromTemplate} data-testid={`${testId}-template-switch`} />
        </label>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-transparent border-[#2A2E39] text-slate-300 hover:bg-[#1C2029] hover:text-white" data-testid={`${testId}-cancel-btn`}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={() => onConfirm(fromTemplate)} className="bg-[#FF3838] hover:bg-red-500 text-white" data-testid={`${testId}-confirm-btn`}>Remover</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
